import React from "react";
import { Link } from "react-router-dom";
import CLINIC_CONFIG from "../../../config/clinicConfig";
import "./MobileServicesSection.css";

const locationSuffix = `-${CLINIC_CONFIG.city.toLowerCase()}-${CLINIC_CONFIG.stateShortForm.toLowerCase()}`;

const mobileServices = [
  {
    image: "/images/hero/Cleaning.webp",
    alt: `Dental Cleaning in ${CLINIC_CONFIG.city} ${CLINIC_CONFIG.stateShortForm}`,
    title: "Dental Cleaning",
    description: "Professional cleaning to remove plaque, prevent cavities, and keep your smile healthy.",
    knowMorePath: `/dental-cleaning-and-prevention${locationSuffix}`,
  },
  {
    image: "/images/hero/Crowns.webp",
    alt: `Dental Crowns in ${CLINIC_CONFIG.city} ${CLINIC_CONFIG.stateShortForm}`,
    title: "Dental Crowns",
    description: "Restore cracked or damaged teeth with custom-fitted crowns that look and feel natural.",
    knowMorePath: "/crowns",
  },
  {
    image: "/images/hero/rootcanal.webp",
    alt: `Root Canal Treatment in ${CLINIC_CONFIG.city} ${CLINIC_CONFIG.stateShortForm}`,
    title: "Root Canal",
    description: "Relieve tooth pain and save your natural tooth with gentle, effective root canal therapy.",
    knowMorePath: `/root-canal-treatment${locationSuffix}`,
  },
  {
    image: "/images/cosmeticdentistry/2.webp",
    alt: `Teeth Whitening in ${CLINIC_CONFIG.city} ${CLINIC_CONFIG.stateShortForm}`,
    title: "Teeth Whitening",
    description: "Brighten your smile with professional whitening treatments for lasting, stunning results.",
    knowMorePath: "/teeth-whitening",
  },
];

const MobileServicesSection: React.FC = () => {
  return (
    <section className="mobile-services-section d-block d-lg-none py-4">
      <div className="container">
        <Link to="/services/" className="mobile-services-heading-link">
          <h2 className="mobile-services-heading text-center mb-4">Our Dental Services in {CLINIC_CONFIG.city}, {CLINIC_CONFIG.stateShortForm}</h2>
        </Link>
        <div className="row g-3">
          {mobileServices.map((service, idx) => (
            <div key={idx} className="col-12">
              <div className="mobile-service-card">
                <Link to={service.knowMorePath} className="mobile-service-img-link">
                  <div className="mobile-service-img-wrap">
                    <img
                      src={service.image}
                      alt={service.alt}
                      className="mobile-service-img"
                      loading="lazy"
                    />
                    <div className="mobile-service-overlay" />
                  </div>
                </Link>
                <div className="mobile-service-body">
                  <h3 className="mobile-service-title">{service.title}</h3>
                  <p className="mobile-service-desc">{service.description}</p>
                </div>
                <div className="mobile-service-actions">
                  <Link
                    to="/book-appointment"
                    className="mobile-service-btn mobile-service-btn--primary"
                  >
                    Schedule Now
                  </Link>
                  <Link
                    to={service.knowMorePath}
                    className="mobile-service-btn mobile-service-btn--outline"
                  >
                    Know More !
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MobileServicesSection;
